import { Box, Grid } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { SERVER_URI } from "../../utils/config"
import { SingleFeedback } from "./SingleFeedback"

export const Feedbacks = () => {
	const [feedbacks, setFeedbacks] = useState([])
	const getFeedbacks = async () => {
		try {
			const response = await axios.get(`${SERVER_URI}/get_feedbacks`)
			const filteredFeedbacks = response.data.feedbacks.filter((feedback) => feedback.message !== "YHTEYDENOTTOPYYNTÖ")
			setFeedbacks(filteredFeedbacks)
		} catch (error) {
			console.error(error)
		}
	}
	useEffect(() => {
		getFeedbacks()
	}, [])

	return (
		<Box
			sx={{
				justifyContent: "center",
				alignContent: "center",
				textAlign: "center",
			}}>
			<Grid container spacing={2} columns={4}>
				{feedbacks.map((item) => (
					<SingleFeedback key={item.feedbackid} item={item} />
				))}
			</Grid>
		</Box>
	)
}
